module.exports = __webpack_public_path__ + "img/has_account.59b319e3.svg";